import { isFeatureEnabled } from '@apply/store/src/user/types';
import { FeatureType } from '@apply/constants';
import { UserStore } from '@apply/store';

export const checkFeatureAndAuth = (feature: FeatureType) => {
    const auth = UserStore.Types.retrieve();
    if (!auth || !auth.user) {
        return false;
    } else {
        return isFeatureEnabled(auth.user, feature);
    }
};
